export default "__VITE_ASSET__Dh9P14v8__"